import request from "@/http";
/**
 * 关于我们-banner
 * @returns
 */
const getAboutBanner = (data) => {
        let { isloading = false } = data;
        return request.get({
            url: "duzikai_api_mgr_public_front_page",
            data: {
                invoke_method: "public_page_4m_load_page_list",
                pre_db_para_begin_idx:0,
                pre_db_para_length_4_list:10,
                type_page_front: 2,
                id_public_agent_info: 99101,
                is_online: 0,
                front_page_remark_001: 101
            },
            loading: {
                enabled: isloading
            }
        });
    }
    /**
     * 关于我们-二维码列表
     * @returns
     */
const getQrcodeList = (data) => {
    let { isloading = false } = data;
    return request.get({
        url: "duzikai_api_mgr_public_front_page",
        data: {
            invoke_method: "public_page_4m_load_page_list",
            pre_db_para_begin_idx:0,
            pre_db_para_length_4_list:10,
            type_page_front: 3,
            id_public_agent_info: 99101,
            is_online: 0
        },
        loading: {
            enabled: isloading
        }
    });
}

const getHomeBanner = (data) => {
    let { isloading = false } = data;
    return request.post({
        url: "duzikai_api_mgr_public_front_page",
        data: {
            invoke_method: "public_page_4m_load_page_list",
            pre_db_para_begin_idx:0,
            pre_db_para_length_4_list:100,
            type_page_front: 101,
            id_public_agent_info: 99101,
            is_online: 0,
            pre_db_para_order_by_para: 'data_weight desc'
        },
        loading: {
            enabled: isloading
        }
    });
}
export default {
    getAboutBanner,
    getQrcodeList,
    getHomeBanner
}
